import { Injectable } from '@angular/core';

export interface StorageItem {
  key: string;
  value: any;
}

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() { }

  public setItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public getItem(key: string): any {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      return null;
    }
  }

  public removeItem(key: string): void {

    localStorage.removeItem(key);

  }

  public clear(): void {
    localStorage.clear();
  }

}
